import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Slider from '../Slider';
import './slider.scss';
import _ from 'lodash';

const sliderOptions = {
  freeMode: true,
  slidesPerView: 8,
  // slidesPerView: "auto",
  loop: true,
  lazy: false,
  spaceBetween: 5,
  preventClicks: false,
  preventClicksPropagation: false,
  speed: 300,
  breakpoints: {
    480: {
      slidesPerView: 4,
      spaceBetween: 5
    },
    800: {
      slidesPerView: 6,
      spaceBetween: 5
    }
  }
}

const contextTypes = {
  router: PropTypes.object
};

const ACTIVE_SUB_ITEM_CLASS = 'active';

class MobileCamGroupCarousel extends Component {

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.swiper.$el[0].addEventListener('click', this.delegateDuplicateClicks);
    this.handleResize();
    const { activeCamGroupId } = this.props;
    const { slides, currentBreakpoint } = this.swiper;
    const match = Array.prototype.slice.call(slides).find((s) => {
      return parseInt(s.dataset.camGroupId, 10) === activeCamGroupId;
    });
    if (match) {
      const offsetPadding = currentBreakpoint === "max" ? sliderOptions.slidesPerView : sliderOptions.breakpoints[currentBreakpoint].slidesPerView;
      const index = parseInt(match.dataset.swiperSlideIndex, 10);
      this.swiper.slideTo(index + offsetPadding);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.swiper.$el[0].removeEventListener('click', this.delegateDuplicateClicks);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.navChannelId !== nextProps.navChannelId && this.swiper) {
      const { slides, navChannelId } = nextProps;
      const channelId = parseInt(navChannelId, 10);
      let camgroup = slides.find( group => _.get(group, 'carouselChannelId') === channelId && _.get(group, 'isInitialChannelCamgroup'));
      if (channelId === 0) {
        camgroup = slides[0];
      }
      if (!camgroup) {
        camgroup = slides.find((group) => {
          if (!_.isArray(group.channelIds)) return false;
          return group.channelIds.includes(channelId);
        });
      }
      if (camgroup) {
        const { slides, currentBreakpoint } = this.swiper;
        let match =  Array.prototype.slice.call(slides).find( (s) => {
          return parseInt(s.dataset.camGroupId, 10) === camgroup.camgroupId &&
            parseInt(s.dataset.channelId, 10) === channelId;
        });
        if (match) {
          let offsetPadding = currentBreakpoint === "max" ? sliderOptions.slidesPerView : sliderOptions.breakpoints[currentBreakpoint].slidesPerView;
          let index = parseInt(match.dataset.swiperSlideIndex, 10);
          this.swiper.slideTo(index+offsetPadding);
        }
      }
    }
  }

  /**
   *
   * As we are using a react wrapper for a jQuery library, if you
   * swipe too quickly, objects are still labeled as "duplicate" and do
   * not get the react synthetic events bound to it. As such, we are binding
   * an event delegation to the $wrapperEl to determine if the item clicked is
   * a `swiper` slide, and dispatch the normal `handleClick` on that element.
   * We are also handling the marking of the current element as `active` and removing
   * that class from all other possible "duplicate" slides.
   *
   * @param  {Event Object} e The event for clicking the the this.swiper.$wrapperEl
   *
   */
  delegateDuplicateClicks = (e) => {
    const { slides } = this.props;
    const slide = e.target.closest('.swiper-slide');
    if(slide) {
      this.swiper.$wrapperEl[0].childNodes.forEach( cel => {
        if(cel.className.includes(ACTIVE_SUB_ITEM_CLASS)) {
          cel.classList.remove(ACTIVE_SUB_ITEM_CLASS)
        }
      });
      e.target.classList.add(ACTIVE_SUB_ITEM_CLASS);

      const camgroup = slides.find((group) => {
        return parseInt(slide.dataset.camGroupId, 10) === group.camgroupId;
      });

      if (camgroup) {
        this.handleClick(e, camgroup);
      }
    }
  }

  handleResize = () => {
    if(this.swiper) {
      this.swiper.update();
    }
  }

  handleClick = (e, camgroup) => {
    if ($(e.target).hasClass('info-btn')) return;
    const { camGroups, setCurrentItem } = this.props;
    setCurrentItem(camgroup.camgroupId, camGroups, camgroup.feedId);
    this.context.router.push(camgroup.url);
    e.preventDefault();
  }

  render() {
    const { handleClick, showInfo } = this;
    const { slides, activeCamGroupId } = this.props;
    return (
      <div className="nav-group main-cam-carousel">
        <Slider
          containerClass="swiper-container cam-group-swiper"
          ref={ node => { if(node) this.swiper = node.swiper } }
          {...sliderOptions}
        >
          {
            slides.map( (camgroup, index) => {
              const displayText = camgroup.title;
              const isActive = activeCamGroupId === camgroup.camgroupId;
              const isActiveClass = (isActive) ? 'active' : '';
              const description = (camgroup.description) ?
                camgroup.description : '';
              const continuedDescription = (camgroup.continued_description) ?
                camgroup.description : '';
              return (
                <a
                  key={index}
                  className="cam-group-item channel-poster"
                  onClick={ (e) => this.handleClick(e, camgroup)}
                  data-cam-group-id={camgroup.camgroupId}
                  data-feed-id={camgroup.feedId}
                  data-channel-id={camgroup.carouselChannelId}
                >
                  <div className="cam-group-item-wrapper aspect-2-3">
                    <div className="cam-group-inner-content">
                      <img
                        src={camgroup.imageUrl ? camgroup.imageUrl.replace('http://', 'https://') : ''}
                        alt={camgroup.title}
                      />
                      <div className="cam-item-overlay">
                        <div data-headline="" className={`${isActiveClass} align-items-center`}>
                          <div style={{ margin: '0 auto' }}>
                            <div className="display-text truncate-overflow u-textSize-12">
                              {displayText}
                            </div>
                            <div className="live-cam-label-separator" />
                            <div className="livecam-count ${showCount} u-textSize-12">
                              {camgroup.feedCount}<br />
                              streams
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </a>
              )
            })
          }
        </Slider>
      </div>
    );
  }

}

MobileCamGroupCarousel.contextTypes = contextTypes;

export default MobileCamGroupCarousel;
